export enum HistoryApiList {
  HistoryFilters = '/history/v1/filters',
  HistoryCards = '/history/v1/cards',
  HistoryRecommended = '/history/v1/cards/recommended',
  HistoryProfileUpdated = '/history/v1/cards/profile-updated',
  HistoryProfileViewers = '/history/v1/cards/profile-viewers',
}
